import PQueue from 'p-queue'

const queue = new PQueue({ concurrency: 3 })

export async function compress (file: File, options?: any) {
  // 好吧，忘了这里为啥要异步加载了
  const Compress = await import('@yireen/squoosh-browser')
  const {
    encoderMap,
    defaultPreprocessorState,
    defaultProcessorState
  } = await import('@yireen/squoosh-browser/dist/client/lazy-app/feature-meta')

  let encoderState
  const fileType = options.target || file.type
  console.log(options.target, file.type, file)
  if (fileType === 'image/jpeg') {
    encoderState = {
      type: 'mozJPEG',
      options: encoderMap.mozJPEG.meta.defaultOptions
    }
  } else if (fileType === 'image/png') {
    encoderState = {
      type: 'oxiPNG',
      options: encoderMap.oxiPNG.meta.defaultOptions
    }
  } else if (fileType === 'image/avif') {
    encoderState = {
      type: 'avif',
      options: encoderMap.avif.meta.defaultOptions
    }
  } else {
    encoderState = {
      type: 'webP',
      options: encoderMap.webP.meta.defaultOptions
    }
  }
  const comp = new Compress.default(file, {
    encoderState: encoderState as any,
    preprocessorState: defaultPreprocessorState,
    processorState: defaultProcessorState
  })
  return queue.add(() => comp.process()) 
}